import { generateTypes } from '../../utils/HttpReducerHelper';

export const fundingReportMatches = generateTypes('FUNDING_REPORT', 'MATCHES');
